<template>
  <div class="profile-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>个人中心</span>
      </div>

      <el-row :gutter="40">
        <!-- 左侧头像区域 -->
        <el-col :xs="24" :sm="8" :md="6">
          <div class="avatar-uploader">
            <el-upload
                class="avatar-uploader"
                action="/api/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            >
            <img v-if="user.avatar" :src="user.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">点击上传头像</div>
          </div>

          <div class="user-info">
            <h3>{{ user.username }}</h3>
            <p>{{ user.role }}</p>
            <p>注册时间: {{ user.registerTime }}</p>
          </div>
        </el-col>

        <!-- 右侧信息区域 -->
        <el-col :xs="24" :sm="16" :md="18">
          <el-tabs v-model="activeTab">
            <!-- 基本信息 -->
            <el-tab-pane label="基本信息" name="basic">
              <el-form ref="basicForm" :model="user" label-width="100px">
                <el-form-item label="用户名">
                  <el-input v-model="user.username" disabled></el-input>
                </el-form-item>

                <el-form-item label="昵称">
                  <el-input v-model="user.nickname"></el-input>
                </el-form-item>

                <el-form-item label="邮箱" prop="email" :rules="[
                  { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                  { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ]">
                  <el-input v-model="user.email"></el-input>
                </el-form-item>

                <el-form-item label="手机号">
                  <el-input v-model="user.phone"></el-input>
                </el-form-item>

                <el-form-item label="性别">
                  <el-radio-group v-model="user.gender">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                    <el-radio :label="0">保密</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="个人简介">
                  <el-input type="textarea" v-model="user.bio" :rows="3"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="updateBasicInfo">保存修改</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <!-- 安全设置 -->
            <el-tab-pane label="安全设置" name="security">
              <el-form ref="securityForm" :model="securityForm" label-width="100px" :rules="securityRules">
                <el-form-item label="当前密码" prop="currentPassword">
                  <el-input type="password" v-model="securityForm.currentPassword" show-password></el-input>
                </el-form-item>

                <el-form-item label="新密码" prop="newPassword">
                  <el-input type="password" v-model="securityForm.newPassword" show-password></el-input>
                  <div class="password-strength">
                    <span :class="{'active': passwordStrength >= 1}">弱</span>
                    <span :class="{'active': passwordStrength >= 2}">中</span>
                    <span :class="{'active': passwordStrength >= 3}">强</span>
                  </div>
                </el-form-item>

                <el-form-item label="确认密码" prop="confirmPassword">
                  <el-input type="password" v-model="securityForm.confirmPassword" show-password></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="updatePassword">修改密码</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>

            <!-- 账号绑定 -->
            <el-tab-pane label="账号绑定" name="account">
              <div class="account-binding">
                <div class="binding-item">
                  <div class="binding-info">
                    <i class="el-icon-mobile-phone"></i>
                    <span>手机</span>
                    <span v-if="user.phone">{{ user.phone }}</span>
                    <span v-else class="unbind">未绑定</span>
                  </div>
                  <el-button type="text" @click="handleBind('phone')">
                    {{ user.phone ? '更换' : '绑定' }}
                  </el-button>
                </div>

                <div class="binding-item">
                  <div class="binding-info">
                    <i class="el-icon-message"></i>
                    <span>邮箱</span>
                    <span v-if="user.email">{{ user.email }}</span>
                    <span v-else class="unbind">未绑定</span>
                  </div>
                  <el-button type="text" @click="handleBind('email')">
                    {{ user.email ? '更换' : '绑定' }}
                  </el-button>
                </div>

                <div class="binding-item">
                  <div class="binding-info">
                    <i class="el-icon-wechat"></i>
                    <span>微信</span>
                    <span v-if="user.wechat">已绑定</span>
                    <span v-else class="unbind">未绑定</span>
                  </div>
                  <el-button type="text" @click="handleBind('wechat')">
                    {{ user.wechat ? '解绑' : '绑定' }}
                  </el-button>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-card>

    <!-- 绑定对话框 -->
    <el-dialog :title="bindTitle" :visible.sync="bindDialogVisible" width="30%">
      <el-form v-if="bindType === 'phone'">
        <el-form-item label="手机号">
          <el-input v-model="bindForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="bindForm.code" placeholder="请输入验证码" style="width: 60%"></el-input>
          <el-button type="primary" plain style="width: 35%; margin-left: 5%"
                     :disabled="codeCountdown > 0" @click="sendCode">
            {{ codeCountdown > 0 ? `${codeCountdown}秒后重试` : '获取验证码' }}
          </el-button>
        </el-form-item>
      </el-form>

      <el-form v-else-if="bindType === 'email'">
        <el-form-item label="邮箱">
          <el-input v-model="bindForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="bindForm.code" placeholder="请输入验证码" style="width: 60%"></el-input>
          <el-button type="primary" plain style="width: 35%; margin-left: 5%"
                     :disabled="codeCountdown > 0" @click="sendCode">
            {{ codeCountdown > 0 ? `${codeCountdown}秒后重试` : '获取验证码' }}
          </el-button>
        </el-form-item>
      </el-form>

      <div v-else-if="bindType === 'wechat'" class="wechat-bind">
        <p>请使用微信扫描下方二维码完成绑定</p>
        <div class="qrcode">
          <!-- 这里应该是微信二维码图片 -->
          <img src="https://dummyimage.com/200x200/eee/999" alt="微信二维码">
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBind">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ProfileView',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value !== this.securityForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'basic',
      user: {
        username: 'admin',
        nickname: '管理员',
        role: '系统管理员',
        avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        email: 'account@example.com',
        phone: '13800138000',
        gender: 1,
        bio: '这是个人简介，可以在这里介绍自己',
        registerTime: '2023-01-01',
        wechat: false
      },
      securityForm: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      securityRules: {
        currentPassword: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ]
      },
      passwordStrength: 0,
      bindDialogVisible: false,
      bindType: '',
      bindTitle: '',
      bindForm: {
        phone: '',
        email: '',
        code: ''
      },
      codeCountdown: 0,
      codeTimer: null
    }
  },
  watch: {
    'securityForm.newPassword'(val) {
      this.checkPasswordStrength(val)
    }
  },
  methods: {
    // 头像上传
    handleAvatarSuccess(res, file) {
      this.user.avatar = URL.createObjectURL(file.raw)
      this.$message.success('头像上传成功')
      // 这里应该调用API更新用户头像
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },

    // 基本信息更新
    updateBasicInfo() {
      this.$refs.basicForm.validate(valid => {
        if (valid) {
          // 调用API更新用户信息
          this.$message.success('基本信息更新成功')
        }
      })
    },

    // 密码强度检查
    checkPasswordStrength(password) {
      let strength = 0
      if (password.length >= 6) strength++
      if (password.match(/[a-z]/) && password.match(/[A-Z]/)) strength++
      if (password.match(/[0-9]/)) strength++
      if (password.match(/[^a-zA-Z0-9]/)) strength++

      this.passwordStrength = Math.min(Math.floor(strength / 2), 3)
    },

    // 修改密码
    updatePassword() {
      this.$refs.securityForm.validate(valid => {
        if (valid) {
          // 调用API修改密码
          this.$message.success('密码修改成功')
          this.securityForm = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          }
        }
      })
    },

    // 账号绑定
    handleBind(type) {
      this.bindType = type
      this.bindDialogVisible = true

      switch (type) {
        case 'phone':
          this.bindTitle = this.user.phone ? '更换手机号' : '绑定手机号'
          this.bindForm.phone = this.user.phone || ''
          break
        case 'email':
          this.bindTitle = this.user.email ? '更换邮箱' : '绑定邮箱'
          this.bindForm.email = this.user.email || ''
          break
        case 'wechat':
          this.bindTitle = this.user.wechat ? '解绑微信' : '绑定微信'
          break
      }
    },

    // 发送验证码
    sendCode() {
      if (this.bindType === 'phone' && !this.bindForm.phone) {
        this.$message.error('请输入手机号')
        return
      }

      if (this.bindType === 'email' && !this.bindForm.email) {
        this.$message.error('请输入邮箱')
        return
      }

      // 模拟发送验证码
      this.$message.success('验证码已发送')
      this.codeCountdown = 60
      this.codeTimer = setInterval(() => {
        if (this.codeCountdown > 0) {
          this.codeCountdown--
        } else {
          clearInterval(this.codeTimer)
        }
      }, 1000)
    },

    // 确认绑定
    confirmBind() {
      if (this.bindType === 'wechat') {
        this.user.wechat = !this.user.wechat
        this.$message.success(this.user.wechat ? '微信绑定成功' : '微信解绑成功')
      } else if (this.bindType === 'phone') {
        if (!this.bindForm.code) {
          this.$message.error('请输入验证码')
          return
        }
        this.user.phone = this.bindForm.phone
        this.$message.success('手机号绑定成功')
      } else if (this.bindType === 'email') {
        if (!this.bindForm.code) {
          this.$message.error('请输入验证码')
          return
        }
        this.user.email = this.bindForm.email
        this.$message.success('邮箱绑定成功')
      }

      this.bindDialogVisible = false
    }
  },
  beforeDestroy() {
    if (this.codeTimer) {
      clearInterval(this.codeTimer)
    }
  }
}
</script>

<style scoped>
.profile-container {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.avatar-uploader {
  text-align: center;
  margin-bottom: 20px;
}

.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
  height: 150px;
  display: block;
  margin: 0 auto;
}

.avatar-uploader >>> .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
}

.user-info {
  text-align: center;
  margin-top: 20px;
}

.user-info h3 {
  margin-bottom: 5px;
}

.user-info p {
  margin: 5px 0;
  color: #909399;
  font-size: 14px;
}

.password-strength {
  display: flex;
  margin-top: 10px;
}

.password-strength span {
  flex: 1;
  text-align: center;
  padding: 2px 0;
  background: #f0f0f0;
  color: #909399;
  margin-right: 5px;
}

.password-strength span:last-child {
  margin-right: 0;
}

.password-strength span.active {
  background: #67C23A;
  color: #fff;
}

.account-binding {
  padding: 0 20px;
}

.binding-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #ebeef5;
}

.binding-info {
  display: flex;
  align-items: center;
}

.binding-info i {
  font-size: 20px;
  margin-right: 10px;
  color: #409EFF;
}

.binding-info span {
  margin-right: 10px;
}

.binding-info .unbind {
  color: #F56C6C;
}

.wechat-bind {
  text-align: center;
}

.wechat-bind p {
  margin-bottom: 20px;
}

.qrcode {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  border: 1px solid #ebeef5;
  padding: 10px;
}

.qrcode img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@media (max-width: 768px) {
  .box-card {
    padding: 15px;
  }

  .avatar-uploader >>> .el-upload {
    width: 120px;
    height: 120px;
  }

  .avatar-uploader-icon {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  .avatar {
    width: 120px;
    height: 120px;
  }

  .account-binding {
    padding: 0;
  }
}

@media (max-width: 576px) {
  .el-col {
    margin-bottom: 20px;
  }

  .avatar-uploader >>> .el-upload {
    width: 100px;
    height: 100px;
  }

  .avatar-uploader-icon {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  .avatar {
    width: 100px;
    height: 100px;
  }

  .el-dialog {
    width: 90% !important;
  }
}
</style>